module.exports = __webpack_public_path__ + "static/media/angle-arrow.c134c5d9.svg";